import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const SolarDatepicker = ({ setStartDate, setEndDate }) => {
  const [localStartDate, setLocalStartDate] = useState(null);
  const [localEndDate, setLocalEndDate] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {

    const storedStartDate = localStorage.getItem("startDate");
    const storedEndDate = localStorage.getItem("endDate");

    if (storedStartDate && storedEndDate) {
      setLocalStartDate(storedStartDate);
      setLocalEndDate(storedEndDate);
      setStartDate(storedStartDate);
      setEndDate(storedEndDate);
    } else {
      const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
      setLocalStartDate(yesterday);
      setLocalEndDate(yesterday);
      setStartDate(yesterday);
      setEndDate(yesterday);
      localStorage.setItem("startDate", yesterday);
      localStorage.setItem("endDate", yesterday);
    }

    setIsLoaded(true);
  }, [setStartDate, setEndDate]);

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setLocalStartDate(dateStrings[0]);
      setLocalEndDate(dateStrings[1]);
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);
      localStorage.setItem("startDate", dateStrings[0]);
      localStorage.setItem("endDate", dateStrings[1]);
    } else {
      setLocalStartDate(null);
      setLocalEndDate(null);
      setStartDate(null);
      setEndDate(null);
      localStorage.removeItem("startDate");
      localStorage.removeItem("endDate");
    }
  };

  const rangePresets = [
    { label: "Yesterday", value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")] },
    { label: "Last Week", value: [dayjs().subtract(1, "week"), dayjs().subtract(1, "day")] },
    { label: "Last Month", value: [dayjs().subtract(1, "month"), dayjs().subtract(1, "day")] },
    { label: "Last Quarter", value: [dayjs().subtract(3, "months"), dayjs().subtract(1, "day")] },
  ];

  const disableFutureDates = (current) => current && current > dayjs().endOf("day");

  return (
    <div className="range-picker-container">
      {isLoaded && (
        <RangePicker
          presets={rangePresets}
          onChange={onRangeChange}
          disabledDate={disableFutureDates}
          className="custom-range-picker"
          value={localStartDate && localEndDate ? [dayjs(localStartDate), dayjs(localEndDate)] : []}
          allowClear
        />
      )}
    </div>
  );
};

export default SolarDatepicker;
